import { registerMetaPixel } from "./meta/registerMetaPixel";

export function registerMarketingDataPartners() {
  registerMetaPixel();
}
